import { make } from 'vuex-pathify'

const state = {
  scrollbarWidth: 0
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations
}
